import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

// Lazy load page components for better performance
const Home = React.lazy(() => import('./components/pages/Home').then(module => ({ default: module.Home })));
const Products = React.lazy(() => import('./components/pages/Products').then(module => ({ default: module.Products })));
const Gallery = React.lazy(() => import('./components/pages/Gallery').then(module => ({ default: module.Gallery })));
const Contact = React.lazy(() => import('./components/pages/Contact/Contact').then(module => ({ default: module.Contact })));
const ProductDetail = React.lazy(() => import("./components/pages/ProductDetail").then(module => ({ default: module.ProductDetail })));

// Loading fallback component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Yükleniyor...
  </div>
);

export const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/detail/:productSlug" element={<ProductDetail />} />
          <Route path="/products/:categorySlug" element={<Products />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </>
  );
};